import $ from "jquery";
import { colors } from "laravel-mix/src/Log";

$(function () {
	if ($(".collections-page").length) {
		let filterGroups = $(".collection-sidebar-group"),
			filterForm = $(".filter-form");

		filterGroups.each(function (e, i) {
			let filterOptions = $(this).find("input");

			filterOptions.on("change", function () {
				if (
					$(this).attr("name") !== "filter.v.price.gte" &&
					$(this).attr("name") !== "filter.v.price.lte"
				) {
					filterForm.submit();
				}
			});

			let filterGroupTitle = $(this).find("h3"),
				filterGroupOptions = $(this).find(
					".collection-sidebar-group-options"
				);

			filterGroupTitle.on("click", function () {
				if ($(window).width() > 768) return;

				filterGroupOptions.slideToggle();
				$(this).toggleClass("filter-open");
			});
		});

		$(".collection-price-filter-options li").on("click", function () {
			let min = $(this).data("min-value"),
				max = $(this).data("max-value");

			$('input[name="filter.v.price.gte"]').val(min);
			$('input[name="filter.v.price.lte"]').val(max);

			filterForm.submit();
		});
	}
	let collectionColorSwatches = $(
		".product-list-item .collection-color-swatch-selection"
	);

	collectionColorSwatches.on("click", function (e) {
		if ($(this).hasClass("more-colors")) return true;

		e.preventDefault();

		let productContainer = $(this).closest(".product-list-item"),
			newUrl = $(this).attr("href"),
			imgSrc = $(this).data("image-src"),
			variantPrice = $(this).find(".color-option-item").data("price"),
			variantCompareAtPrice = $(this)
				.find(".color-option-item")
				.data("compare-at-price"),
			variantUseCompareAtPrice = $(this)
				.find(".color-option-item")
				.data("use-compare-at-price"),
			colorLabel = $(this).find(".color-option-item").data("value");

		productContainer
			.find(".collection-color-swatch-selection")
			.not($(this))
			.find(".color-option-item")
			.removeClass("selected");
		$(this).find(".color-option-item").addClass("selected");

		productContainer
			.find(".collection-swatch-selection-url")
			.attr("href", newUrl);

		productContainer.find(".product-color-selected").text(colorLabel);

		productContainer.find(".product-price-selected").text(variantPrice);
		productContainer
			.find(".product-compare-at-price-selected")
			.text(variantCompareAtPrice);
		if (variantUseCompareAtPrice * 1) {
			productContainer.find(".product-compare-at-price-container").show();
		} else {
			productContainer.find(".product-compare-at-price-container").show();
		}

		if (imgSrc.length) {
			productContainer
				.find(".product-image")
				.find("img")
				.not(".secondary")
				.attr("src", imgSrc);
		}
	});

	function isElementInViewport(el) {
		var rect = el.getBoundingClientRect();
		return (
			// rect.top >= 0 &&
			// rect.left >= 0 &&
			rect.bottom >= 0 && // if bottom < 0, element has scrolled out of view
			// rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */

			rect.top <=
				(window.innerHeight || document.documentElement.clientHeight)
		);
	}

	let previousState = sessionStorage.getItem(
		"last-state-v2-" + $("#collection-wrapper").data("id")
	);
	if (previousState) {
		$("#collection-wrapper").html(previousState);
		$("body").trigger("collectionItemsAdded");
	}

	function haveMorePages($el) {
		return $el.find("span.next").length > 0;
	}

	let el = document.getElementById("collection-pagination");
	if (el) {
		const paginationSelector = "#collection-pagination";
		let fetching = false;
		let morePages = haveMorePages($(paginationSelector));
		$(window).on("scroll", function () {
			if (isElementInViewport(el)) {
				if (fetching) return;
				if (morePages) {
					fetching = true;
					$("#collection-loading").show();
					$.get({
						url: $(paginationSelector)
							.find("span.next a")
							.attr("href"),
						success: function (data, textStatus, jqXHR) {
							// something went wrong, let's show the pagination so things aren't toally broken
							if (textStatus !== "success") {
								$(paginationSelector).css({
									visibility: "visible",
								});
								return;
							}
							let $dom = $(data);

							// incoming DOM will have a new loading bar
							$("#collection-loading").remove();
							// insert new items
							$("#collection-results").append(
								$dom.find("#collection-results").html()
							);
							// populate new pagination
							$(paginationSelector).html(
								$dom.find(paginationSelector).html()
							);
							// save to restore DOM
							// sessionStorage.setItem(
							// 	"last-state-v2-" +
							// 		$("#collection-wrapper").data("id"),
							// 	$("#collection-wrapper").html()
							// );
							$("body").trigger("collectionItemsAdded");
							// update state
							morePages = haveMorePages($(paginationSelector));
							fetching = false;
						},
					});
				}
			}
		});
	}
});
